import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Bracket from "./views/Bracket.vue";
import AllTeams from "./views/AllTeams.vue";
import Match from "./views/Match.vue";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/en",
      name: "home-en",
      component: Home
    },
    {
      path: "/all-teams",
      name: "allteams",
      component: AllTeams
    },
    {
      path: "/bracket",
      name: "bracket",
      component: Bracket
    },
    {
      path: "/match/:id",
      name: "match",
      component: Match,
      props: true
    }
  ],
  linkActiveClass: "link-active",
  linkExactActiveClass: "active",
});

// Global navigation guard to handle language switching
router.beforeEach((to, from, next) => {
  // Check if user is accessing /en route
  if (to.path === '/en') {
    // Set language to English and remember it
    localStorage.setItem('language', 'en');
    if (router.app && router.app.$i18n) {
      router.app.$i18n.locale = 'en';
    }
  } else {
    // For all other routes, use the saved language preference
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && router.app && router.app.$i18n) {
      router.app.$i18n.locale = savedLanguage;
    }
  }
  next();
});

export default router;